import { Box, Button, Grid } from "@mui/material";
import { useComment } from "@platformx/authoring-apis";
import { CommentWrapper } from "@platformx/comment-review";
import { ErrorMessageHandle } from "@platformx/schema-based-content-type";
import { CommonBoxWithNumber, TitleSubTitle } from "@platformx/utilities";
import { useTranslation } from "react-i18next";
import { useCustomStyle } from "../../quiz.style";
import { DraggableQuestions } from "./DragableQuestions";

export const Question = ({
  quizState,
  setQuizState,
  onClickAddQuestion,
  setIsClickedQueList,
  onClickEditQuestion,
  isError,
}) => {
  const onClickQueList = () => {
    setIsClickedQueList(true);
  };
  const { t } = useTranslation();
  const { scrollToRef } = useComment();
  const classes = useCustomStyle();
  return (
    <Box id='questions' className={classes.mainStyleWrapper}>
      <CommentWrapper elementId='3' scrollRef={scrollToRef}>
        <CommonBoxWithNumber
          number='03'
          title={t("quiz_question_head")}
          titleVarient='h5bold'
          subTitleVarient='p4regular'
          subTitle={t("subhead")}>
          <Grid container>
            <Grid item xs={12} sm={12} md={5} em={5} className='leftFiledLast'>
              <TitleSubTitle
                title={`${t("quiz_question_head")}*`}
                subTitle={t("quiz_question_subtitle")}
                titleVariant='h6medium'
                subTitleVariant='p4regular'
              />
            </Grid>
            <Grid item xs={12} sm={12} md={7} em={7}>
              <Box
                sx={{
                  ".draggable-category": {
                    paddingRight: "0",
                  },
                }}>
                <DraggableQuestions
                  quizState={quizState}
                  setQuizState={setQuizState}
                  onClickEditQuestion={onClickEditQuestion}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { sm: "row", xs: "column" },
                  justifyContent: "flex-start",
                  padding: {
                    xs: quizState?.questions?.length > 0 ? "20px 0px 20px 0px" : "none",
                  },
                  // justifyContent:'space-evenly'
                }}>
                <Button
                  variant='primaryButton'
                  data-testid='quiz-addquestion'
                  sx={{
                    margin: { xs: "0 0 10px 0", md: "0 12px 0 0" },
                  }}
                  disabled={quizState?.questions?.length >= 16 ? true : false}
                  onClick={onClickAddQuestion}>
                  {t("add_questions")}
                </Button>

                <Button
                  variant='secondaryButton'
                  onClick={onClickQueList}
                  data-testid='quiz-choosefromlist'>
                  {t("choose_from_list")}
                </Button>
              </Box>
              {isError["questions"] && (
                <ErrorMessageHandle error={{ message: "Field is Required" }} />
              )}
            </Grid>
          </Grid>
        </CommonBoxWithNumber>
      </CommentWrapper>
    </Box>
  );
};
